export enum OrganizationsPaths {
  Create = 'create',
  Users = 'users',
  Settings = 'settings',
}

export enum OrganizationsParams {
  OrganizationId = 'organizationId',
  UserRoleFilter = 'role',
  UserStatusFilter = 'status',
}
